import React, { useCallback, useState } from 'react';
import { Element, Transforms } from 'slate';
import { ReactEditor, useSlateStatic } from 'slate-react';
import { SpacerButton } from './Spacer.styled';

export type SpacerProps = {
  element?: Element;
  isActive?: boolean;
};

/**
 * Spacer Component
 *
 */
export const Spacer = ({ element, isActive }: SpacerProps) => {
  const editor = useSlateStatic();
  /**
   * We need to track isHovered manually (prev this was just a css rule) because
   * because of a chrome bug https://bugs.chromium.org/p/chromium/issues/detail?id=410328
   * which means that drag events and hover rules don't play nicely
   */
  const [isHovered, setIsHovered] = useState(false);

  const insertDefaultNode = useCallback(() => {
    /**
     * we need to compute the current path in our event lister
     * because our component will not have rerendered and recomputed
     * it's path variable
     */
    const path = element != null && ReactEditor.findPath(editor, element);
    const insertAt = Array.isArray(path) ? [path[0] + 1] : [0];
    Transforms.insertNodes(
      editor,
      [
        {
          children: [
            {
              text: '',
            },
          ],
        },
      ],
      {
        at: insertAt,
        select: true,
      }
    );
    ReactEditor.focus(editor);
  }, [editor, element]);

  return (
    /**
     * Elements with contentEditable={false} among editable children need to have children themselves
     * to not be keyboard focusable and to not trigger events for parent elements.
     */
    <SpacerButton
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      data-testid="spacer"
      contentEditable={false}
      isActive={isActive === true || isHovered}
      onClick={insertDefaultNode}
      tabIndex={-1}
      aria-hidden
    >
      <span />
    </SpacerButton>
  );
};
